import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "chat-wrapper" }
const _hoisted_2 = { class: "go-to-latest-button" }

import { ChatItem } from '@/types/chat';
import ChatMessage from '@/components/elements/ChatMessage.vue';
import { nextTick, ref, watch } from 'vue';
import ButtonCustom from '@/components/elements/ButtonCustom';
import useTranslate from '@/utilities/composables/useTranslate';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatWrapper',
  props: {
  items: {
    type: Array<ChatItem>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { translate } = useTranslate();

const scroll = ref(null) as any;
const enableAutoScroll = ref(true);
const scrollProgress = ref(1);
const scrollingFromItem = ref(false);
const scrollingFromItemTimeout = ref(null);

const resetScroll = () => {
  enableAutoScroll.value = true;
  scroll.value.scrollTo({ y: '100%' }, 200, 'easeInOutQuad');
};

const handleScroll = () => {
  scrollProgress.value =
    (scroll.value.getScrollProcess().v * scroll.value.$el.clientHeight) /
    scroll.value.$el.offsetHeight;
};

const handleWheel = (e) => {
  enableAutoScroll.value = scrollProgress.value === 1;

  // Cancel event when reaches end to prevent jittery behavior
  if (scrollProgress.value === 1) e.preventDefault();
};

watch(
  () => props.items,
  () => {
    if (!scroll.value || !enableAutoScroll.value) return;

    scrollingFromItem.value = true;

    if (scrollingFromItemTimeout.value) {
      clearTimeout(scrollingFromItemTimeout.value);
    }

    scrollingFromItemTimeout.value = setTimeout(() => {
      scrollingFromItem.value = false;
    }, 300);

    nextTick(() => {
      scroll.value?.scrollTo({ y: '100%' }, 200, 'easeInOutQuad');
    });
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  const _component_vue_scroll = _resolveComponent("vue-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue_scroll, {
      ref_key: "scroll",
      ref: scroll,
      class: "chat-wrapper-scroll",
      ops: {
        scrollPanel: { scrollingX: false, initialScrollY: '100%', speed: 0 },
        rail: { gutterOfSide: '8px' },
        bar: { disable: true },
      },
      onHandleScroll: handleScroll
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "chat-message-list",
          onWheel: handleWheel
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
            return (_openBlock(), _createBlock(ChatMessage, {
              key: item.id,
              item: item
            }, null, 8, ["item"]))
          }), 128))
        ], 32)
      ]),
      _: 1
    }, 512),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createElementVNode("div", _hoisted_2, [
      (scrollProgress.value !== 1 && !scrollingFromItem.value)
        ? (_openBlock(), _createBlock(_unref(ButtonCustom), {
            key: 0,
            text: _unref(translate)('goToLatest'),
            type: 'note-button secondary-button electron-no-drag',
            "custom-icon-name": 'arrow-down',
            "custom-icon-color": '--var(iconDefault)',
            "custom-icon-size": '16px',
            "button-dimensions": { height: '24px' },
            onClick: resetScroll
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})